module.exports = __webpack_public_path__ + "static/img/linkedin.563af49c.svg";